
import { dictionaryItem } from '@/modules/mdm/api/dict/index';
import { Message } from 'element-ui';
import dayjs from 'dayjs';
// const dataPlugin = {
//     'code': 0,
//     'data': {
//         'CodeMaster.ORG_TEMPR_CATEGORY': {
//             'NT': '常温',
//             'RT': '冷藏',
//             'FT': '冷冻',
//             'TT': '恒温'
//         },
//         'CodeMaster.SYS_SKU_TYPE_ClASS': {
//             '1': '生产产商',
//             '3': '大类',
//             '4': '小类'
//         },
//         'CodeMaster.SYS_WM_RESERVE_CODE': {
//             'MAN': '人工指定库位',
//             'B_RCV_ONE': '收货前计算库位-一步收货',
//             'B_RCV_TWO': '收货前计算库位-两步收货',
//             'RCV': '收货时计算库位',
//             'PA': '上架时计算库位'
//         },
//         'CodeMaster.SYS_BUSINESS_UNIT': {
//             '01': '家用空调事业部',
//             '02': '中央空调事业部',
//             '03': '冰箱事业部',
//             '04': '洗衣机事业部',
//             '05': '微波和清洁事业部',
//             '06': '生活电器事业部',
//             '07': '美的厨房和热水事业部',
//             '08': '环境电器事业部',
//             '09': '洗涤电器事业部',
//             '10': '安得智联',
//             '11': '部品事业部',
//             '12': '集团直属单位',
//             '13': '销司/代理商',
//             '14': '清洁电器事业部',
//             '15': 'AEG合资公司'
//         },
//         'CodeMaster.SYS_CONFIG_STATUS': {
//             '0': '启用',
//             '1': '停用'
//         },
//         'CodeMaster.SYS_YES_NO': {
//             '0': '否',
//             '1': '是'
//         }
//     },
//     'result': 'success',
//     'message': '',
//     'id': null
// };
/**
 * 获取xxx名称
 * 示例:
 * @params val{int} xxx值
 * @return {string} xxx名称
 **/
// eslint-disable-next-line complexity
export function getBusinessUnit(val) {
    switch (val) {
    case '01':
        return '家用空调事业部';
    case '02':
        return '中央空调事业部';
    case '03':
        return '冰箱事业部';
    case '04':
        return '洗衣机事业部';
    case '05':
        return '微波和清洁事业部';
    case '06':
        return '生活电器事业部';
    case '07':
        return '美的厨房和热水事业部';
    case '08':
        return '环境电器事业部';
    case '09':
        return '洗涤电器事业部';
    case '10':
        return '安得智联';
    case '11':
        return '部品事业部';
    case '12':
        return '集团直属单位';
    case '13':
        return '销司/代理商';
    case '14':
        return '清洁电器事业部';
    case '15':
        return 'AEG合资公司';
    default:
        return '';
    }
};
export function getTempLevel(val) {
    switch (val) {
    case 'NT':
        return '常温';
    case 'RT':
        return '冷藏';
    case 'FT':
        return '冷冻';
    case 'TT':
        return '恒温';
    default:
        return '';
    }
};

export function getHierarchy(val) {
    switch (val) {
    case '1':
        return '生产厂商';
    case '2':
        return '小类';
    case '3':
        return '大类';
    default:
        return '';
    }
};
export function getReserveCode(val) {
    switch (val) {
    case 'MAN':
        return '人工指定库位';
    case 'B_RCV_ONE':
        return '收货前计算库位-一步收货';
    case 'B_RCV_TWO':
        return '收货前计算库位-两步收货';
    case 'RCV':
        return '收货时计算库位';
    case 'PA':
        return '上架时计算库位';
    default:
        return '';
    }
};

/**
 * 校验空格，在表单校验的 rules 中使用。
 * 示例:
 * rules: {
 *     roleName: [
 *         { validator: validateNull, trigger: 'blur' }
 *     ]
 * }
 * @params rule{object} 表单校验规则
 * @params value{string} 表单值
 * @params callback{function} 返回
 * @return {function} 带上出错信息的返回
 **/
export function validateNull(rule, value, callback) {
    if (/\s+/.test(value)) {
        return callback(new Error('请勿输入空格'));
    }
    callback();
};
// eslint-disable-next-line complexity
// 判断并请求数据字典,key为数据字典编码
export const setSessionStorage = key => {
    if (!key.length) {
        return new Promise(resolve => resolve());
    }
    return _dictionaryItem(key.join(',')).then(res => {
        const lang = getCookie('lang');
        key.forEach(item => {
            if (res && res[item]) {
                sessionStorage[`${lang}_${item}`] = JSON.stringify(res[item]);
            } else {
                Message.error(`字典编码${item}返回为空`);
            }
        });
    });
};
// 获取数据字典
export const _dictionaryItem = dictCodes => {
    return dictionaryItem({ dictCodes }).then(res => {
        if (res && +res.code === 0) {
            return res.data;
        }
    });
};
// 转化session内的值
export const getSessionKey = (prop, key) => {
    return prop && key ? JSON.parse(key)[prop] : prop;
};
// 初始化遍历所有key
export const initSessionData = (arr) => {
    if (typeof (arr) === 'string' || Array.isArray(arr)) {
        if (typeof (arr) === 'string') {
            arr = arr.split(',');
        }
        return setSessionStorage(isInexistenceSession(arr)).then(res => {
            const lang = getCookie('lang');
            const temp = {};
            arr.forEach(item => {
                temp[item] = JSON.parse(sessionStorage[`${lang}_${item}`]);
            });
            return temp;
        });
    }
};
export const isInexistenceSession = arr => {
    const lang = getCookie('lang');
    return arr.filter(item => {
        return !sessionStorage[`${lang}_${item}`];
    });
};
const getCookie = (name) => {
    let arr = null;
    const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    arr = document.cookie.match(reg);
    if (arr) return unescape(arr[2]);
    else return null;
};
export const handleDictionaryData = temp => {
    const dictionarySelection = [];
    for (const key in temp) {
        if (key && temp[key]) {
            dictionarySelection.push({
                value: +key,
                label: temp[key]
            });
        }
    }
    return dictionarySelection;
};
export const handleDictionaryDataString = temp => {
    const dictionarySelection = [];
    for (const key in temp) {
        if (key && temp[key]) {
            dictionarySelection.push({
                value: key,
                label: temp[key]
            });
        }
    }
    return dictionarySelection;
};

// 处理searchBox时间格式不一致问题
export const handleLocalTime = (params) => {
    const date = new Date(params);
    return dayjs(date.valueOf()).format('YYYY-MM-DD HH:mm:ss');
};

// 字典编码转换成名称显示
export const formatDictCodeToName = (code, dict) => {
    if ((typeof code !== 'number' && !code) || !dict) return '';

    const result = [];
    const list = Array.isArray(code) ? code : String(code).split(',');

    list.forEach((key) => {
        if (dict[key]) {
            result.push(dict[key]);
        }
    });
    return result.join(',');
};
